var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-track-filters"},[_c('div',{staticClass:"mt-track-filters__item"},[_c('r-button',{attrs:{"type":"primary","loading":_vm.loading},on:{"click":_vm.toggleTrack}},[_vm._v(" "+_vm._s(_vm.trackButtonText)+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }